import React from "react";
import { AuthProvider } from "./src/services/AuthContext";
import "./src/styles/global.css";

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
);
